import React from 'react'
import { useTranslation } from 'react-i18next'

import AccountTreeIcon from '@material-ui/icons/Spa'

import { useUpdateFarmTreesMutation } from '../../../../adapters/farms'
import UploadTreesCard from './UploadTreesCard'

export default function UploadTreesFarm({
  farm,
  refetchPlants,
  onUploaded,
  setStatusSnackbar,
  setMessageSnackbar,
  setOpenSnackbar,
}) {
  const { t } = useTranslation()

  const mutateSavePlants = useUpdateFarmTreesMutation()

  const notify = (status, message) => {
    setStatusSnackbar(status)
    setMessageSnackbar(message)
    setOpenSnackbar(true)
  }

  const parcelCount = farm?.farm_parcels?.features?.length

  const handleFileUploading = (files) => {
    if (files.length === 0) return

    mutateSavePlants.mutate(
      { attachments: files, farm_id: farm?.id },
      {
        onSuccess: () => {
          setStatusSnackbar('success')
          setMessageSnackbar(t('plants_upload.success'))
          setOpenSnackbar(true)
          if (onUploaded) onUploaded()
          if (refetchPlants) refetchPlants()
        },
        onError: (error) => {
          setStatusSnackbar('error')
          setMessageSnackbar(t('plants_upload.error'))
          setOpenSnackbar(true)
          console.error('Upload error:', error)
        },
      }
    )
  }

  return (
    <UploadTreesCard
      icon={<AccountTreeIcon />}
      title={t('plants_upload.farm_title')}
      scope={
        parcelCount > 1
          ? t('plants_upload.farm_scope_count', {
              count: parcelCount,
            })
          : t('plants_upload.farm_scope')
      }
      formats={['.geojson', '.kml', '.zip']}
      acceptedFiles={[
        '.geojson',
        '.json',
        '.kml',
        '.zip',
        '.gpkg',
        'application/geo+json',
        'application/json',
        'application/zip',
      ]}
      onRejected={() =>
        notify('error', t('plants_upload.farm_format_error'))
      }
      busy={mutateSavePlants.isLoading}
      busyText={t('plants_upload.uploading')}
      onFiles={handleFileUploading}
    />
  )
}
